import { render, staticRenderFns } from "./viewWinBids.vue?vue&type=template&id=1494b0d3&scoped=true"
import script from "./viewWinBids.vue?vue&type=script&lang=js"
export * from "./viewWinBids.vue?vue&type=script&lang=js"
import style0 from "./viewWinBids.vue?vue&type=style&index=0&id=1494b0d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494b0d3",
  null
  
)

export default component.exports